import { render } from "./NotiSettingsBody.vue?vue&type=template&id=404f8e90"
import script from "./NotiSettingsBody.vue?vue&type=script&lang=js"
export * from "./NotiSettingsBody.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__